export default __webpack_public_path__ + "static/media/transfermovil1.3a2d0fd5.png";